(function () {
  if (window.__fbpLiveSupportChatV2BootstrapLoaded) return;
  window.__fbpLiveSupportChatV2BootstrapLoaded = true;

  var PUBLIC_BASE = 'https://chat.furrybodypillows.com';
  var CHAT_FRAME_TITLE = 'Furry Body Pillows live support chat';
  var CHAT_VERSION = '2026-04-04T21:05:00.000Z';
  var DEFAULT_RIGHT_PX = 18;
  var DEFAULT_BOTTOM_PX = 18;
  var CLEARANCE_PX = 16;
  var MOBILE_FRAME_EDGE_GAP_PX = 8;
  var DEFERRED_LOAD_MS = 4000;
  var MOBILE_STICKY_MENU_SELECTORS = [
    '#shopify-section-mobile-sticky-menu ul.grid-wrap',
    '.mobile-sticky-menu ul.grid-wrap'
  ];
  var CART_OBSTRUCTION_SELECTORS = [
    '#ajaxcart .footer-mini-cart.checkout-btn',
    '#ajaxcart .mini-cart-button',
    '#ajaxcart-checkout',
    '.mini-cart.drawer .footer-mini-cart.checkout-btn',
    '.mini-cart.drawer .mini-cart-button',
    '#fbp-sticky-atc.is-visible',
    '#stickyAtcBar',
    '.sticky-atc-bar',
    '#shopify-section-mobile-sticky-menu',
    '.mobile-sticky-menu',
    '#top',
    'a#top',
    'a.scroll#top',
    '#top.scroll',
    '.scroll#top'
  ];

  var chatFrame = null;
  var mutationObserver = null;
  var scheduleToken = 0;
  var chatScriptRequested = false;
  var hostLayoutWatchStarted = false;
  var fallbackTimer = null;
  var latestFrameState = {
    visible: false,
    open: false,
    width: 0,
    height: 0
  };

  function isVisible(el) {
    if (!el || !el.isConnected) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function injectDockStyles() {
    if (document.getElementById('fbp-live-chat-mobile-dock-style')) return;
    var style = document.createElement('style');
    style.id = 'fbp-live-chat-mobile-dock-style';
    style.textContent = [
      '@media (max-width: 767px) {',
      '  .mobile-sticky-menu .fbp-live-chat-grid-wrapper { display: none; }',
      '  .mobile-sticky-menu .fbp-live-chat-grid-wrapper[data-chat-visible="true"] { display: block; }',
      '  .mobile-sticky-menu .fbp-live-chat-trigger {',
      '    display: flex !important;',
      '    align-items: center !important;',
      '    justify-content: center !important;',
      '    flex-direction: column !important;',
      '    gap: 5px;',
      '    width: 100%;',
      '    min-height: 48px;',
      '    padding: 0 6px;',
      '    border: 0;',
      '    background: transparent;',
      '    color: inherit;',
      '    text-align: center;',
      '  }',
      '  .mobile-sticky-menu .fbp-live-chat-trigger .icon { font-size: 18px; line-height: 1; }',
      '  .mobile-sticky-menu .fbp-live-chat-trigger .title { font-size: 11px; line-height: 1.15; white-space: nowrap; }',
      '  .mobile-sticky-menu .fbp-live-chat-grid-wrapper[data-chat-open="true"] .fbp-live-chat-trigger .icon,',
      '  .mobile-sticky-menu .fbp-live-chat-grid-wrapper[data-chat-open="true"] .fbp-live-chat-trigger .title { color: #c9963e; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function findChatFrame() {
    if (chatFrame && chatFrame.isConnected) return chatFrame;
    chatFrame = document.querySelector('iframe[title="' + CHAT_FRAME_TITLE + '"]');
    return chatFrame;
  }

  function getMobileStickyMenuList() {
    for (var i = 0; i < MOBILE_STICKY_MENU_SELECTORS.length; i += 1) {
      var node = document.querySelector(MOBILE_STICKY_MENU_SELECTORS[i]);
      if (node) return node;
    }
    return null;
  }

  function findStickyItemByTitle(list, title) {
    if (!list) return null;
    var targetTitle = String(title || '').trim().toLowerCase();
    var items = list.querySelectorAll('li.grid-wrapper');
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      var label = (item.querySelector('.title') && item.querySelector('.title').textContent || '').trim().toLowerCase();
      if (label === targetTitle) return item;
    }
    return null;
  }

  function ensureDockTrigger() {
    injectDockStyles();

    var list = getMobileStickyMenuList();
    if (!list) return null;

    var item = list.querySelector('.fbp-live-chat-grid-wrapper');
    if (!item) {
      item = document.createElement('li');
      item.className = 'grid-wrapper fbp-live-chat-grid-wrapper';
      item.setAttribute('data-chat-visible', 'false');
      item.setAttribute('data-chat-open', 'false');
      item.innerHTML = [
        '<button class="icon-block fbp-live-chat-trigger" type="button" aria-label="Open live chat" hidden>',
        '  <span class="icon"><i class="feather-message-circle"></i></span>',
        '  <span class="title">Chat</span>',
        '</button>'
      ].join('');

      var searchItem = findStickyItemByTitle(list, 'search');
      if (searchItem && searchItem.parentNode === list) {
        list.insertBefore(item, searchItem);
      } else {
        list.appendChild(item);
      }
    }

    var trigger = item.querySelector('.fbp-live-chat-trigger');
    if (trigger && trigger.dataset.fbpBound !== 'true') {
      trigger.dataset.fbpBound = 'true';
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (!chatScriptRequested) {
          triggerChatLoad();
          window.setTimeout(function () {
            sendParentCommand('open');
          }, 450);
          return;
        }
        sendParentCommand(latestFrameState.open ? 'close' : 'open');
      });
    }

    return item;
  }

  function updateDockTrigger() {
    var item = ensureDockTrigger();
    if (!item) return;

    var shouldShow = isMobileViewport() && latestFrameState.visible;
    var trigger = item.querySelector('.fbp-live-chat-trigger');

    item.setAttribute('data-chat-visible', shouldShow ? 'true' : 'false');
    item.setAttribute('data-chat-open', latestFrameState.open ? 'true' : 'false');
    item.style.display = shouldShow ? '' : 'none';

    if (!trigger) return;

    trigger.hidden = !shouldShow;
    trigger.setAttribute('aria-expanded', latestFrameState.open ? 'true' : 'false');
    trigger.setAttribute('aria-label', latestFrameState.open ? 'Close live chat' : 'Open live chat');
  }

  function collectObstructionTop() {
    var seen = [];
    var top = null;
    for (var i = 0; i < CART_OBSTRUCTION_SELECTORS.length; i += 1) {
      var nodes = document.querySelectorAll(CART_OBSTRUCTION_SELECTORS[i]);
      for (var j = 0; j < nodes.length; j += 1) {
        var node = nodes[j];
        if (seen.indexOf(node) !== -1 || !isVisible(node)) continue;
        seen.push(node);
        var rect = node.getBoundingClientRect();
        if (rect.bottom > window.innerHeight - 280) {
          top = top === null ? rect.top : Math.min(top, rect.top);
        }
      }
    }
    return top;
  }

  function applyDockedFrameState() {
    var frame = findChatFrame();
    if (!frame) return;

    var width = Math.max(0, Number(latestFrameState.width || 0));
    var height = Math.max(0, Number(latestFrameState.height || 0));
    var isMobile = isMobileViewport();

    if (!latestFrameState.visible) {
      frame.style.width = '0px';
      frame.style.height = '0px';
      frame.style.opacity = '0';
      frame.style.pointerEvents = 'none';
      frame.style.clipPath = '';
      frame.style.webkitClipPath = '';
      return;
    }

    if (isMobile) {
      if (!latestFrameState.open) {
        frame.style.width = '0px';
        frame.style.height = '0px';
        frame.style.opacity = '0';
        frame.style.pointerEvents = 'none';
        frame.style.clipPath = '';
        frame.style.webkitClipPath = '';
        return;
      }

      width = Math.min(Math.max(0, window.innerWidth - (MOBILE_FRAME_EDGE_GAP_PX * 2)), width || 0);
      height = Math.min(Math.max(320, window.innerHeight - 120), height || 0);
    }

    // Desktop icon-only state — the cross-origin chat iframe content
    // (chat.furrybodypillows.com/customer-frame.html) renders the round chat
    // icon at the right edge of a wider 196x82 white-background area, leaving
    // a visible white box to the left of the icon. We can't reach the iframe's
    // CSS from here, so clip the iframe element to a circle that just shows
    // the icon (and its drop shadow). When the chat opens or on mobile, the
    // clip is cleared so the full chat panel renders normally.
    // Numbers tied to current iframe icon-state geometry (196x82, icon centered
    // at right:34, vertical 41% with ~24px icon radius + ~6px shadow halo).
    if (!isMobile && latestFrameState.visible && !latestFrameState.open) {
      var iconClip = 'circle(32px at calc(100% - 34px) 41%)';
      frame.style.clipPath = iconClip;
      frame.style.webkitClipPath = iconClip;
    } else {
      frame.style.clipPath = '';
      frame.style.webkitClipPath = '';
    }

    frame.style.width = width + 'px';
    frame.style.height = height + 'px';
    frame.style.opacity = latestFrameState.visible ? '1' : '0';
    frame.style.pointerEvents = latestFrameState.visible ? 'auto' : 'none';
  }

  function applyChatFrameOffset() {
    var frame = findChatFrame();
    if (!frame) return;

    var isMobile = isMobileViewport();
    var bottom = DEFAULT_BOTTOM_PX;
    var right = isMobile ? MOBILE_FRAME_EDGE_GAP_PX : DEFAULT_RIGHT_PX;
    var obstructionTop = collectObstructionTop();

    if (typeof obstructionTop === 'number' && isFinite(obstructionTop)) {
      bottom = Math.max(DEFAULT_BOTTOM_PX, Math.round(window.innerHeight - obstructionTop + CLEARANCE_PX));
    }

    if (isMobile && latestFrameState.open) {
      right = MOBILE_FRAME_EDGE_GAP_PX;
      bottom = Math.max(bottom, 72);
    }

    frame.style.right = right + 'px';
    frame.style.bottom = bottom + 'px';
  }

  function scheduleChatFrameOffset() {
    if (scheduleToken) return;
    scheduleToken = window.requestAnimationFrame(function () {
      scheduleToken = 0;
      applyDockedFrameState();
      applyChatFrameOffset();
      updateDockTrigger();
    });
  }

  function watchHostLayout() {
    if (hostLayoutWatchStarted) return;
    hostLayoutWatchStarted = true;

    mutationObserver = new MutationObserver(scheduleChatFrameOffset);
    mutationObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'style', 'open'],
      childList: true,
      subtree: true
    });

    window.addEventListener('resize', scheduleChatFrameOffset, { passive: true });
    window.addEventListener('load', scheduleChatFrameOffset, { once: true });
    window.setInterval(scheduleChatFrameOffset, 1000);
    scheduleChatFrameOffset();
  }

  function clearDeferredHandles() {
    if (fallbackTimer) {
      window.clearTimeout(fallbackTimer);
      fallbackTimer = null;
    }
  }

  function removeEarlyListeners() {
    var events = ['pointerdown', 'mousedown', 'click', 'touchstart', 'keydown', 'focusin'];
    for (var i = 0; i < events.length; i += 1) {
      window.removeEventListener(events[i], triggerChatLoad, true);
    }
  }

  function sendParentCommand(action) {
    var frame = findChatFrame();
    if (!frame || !frame.contentWindow) return;
    frame.contentWindow.postMessage({
      type: 'fbp-support-chat-v2:parent-command',
      action: action
    }, '*');
  }

  function triggerChatLoad() {
    if (chatScriptRequested) return;
    chatScriptRequested = true;
    clearDeferredHandles();
    removeEarlyListeners();
    injectDockStyles();
    ensureDockTrigger();

    var script = document.createElement('script');
    script.src = PUBLIC_BASE + '/live-support-chat-v2.js?v=' + encodeURIComponent(CHAT_VERSION);
    script.async = true;
    script.defer = true;
    script.onload = function () {
      watchHostLayout();
      scheduleChatFrameOffset();
    };
    script.onerror = function () {
      console.error('FBP Support Chat V2 failed to load from ' + PUBLIC_BASE);
    };
    (document.head || document.documentElement).appendChild(script);
  }

  function queueDeferredLoad() {
    if (chatScriptRequested) return;
    clearDeferredHandles();
    fallbackTimer = window.setTimeout(triggerChatLoad, DEFERRED_LOAD_MS);
  }

  function armDeferredLoad() {
    var events = ['pointerdown', 'mousedown', 'click', 'touchstart', 'keydown', 'focusin'];
    for (var i = 0; i < events.length; i += 1) {
      window.addEventListener(events[i], triggerChatLoad, { once: true, capture: true, passive: true });
    }

    if (document.readyState === 'complete') {
      queueDeferredLoad();
      return;
    }

    window.addEventListener('load', queueDeferredLoad, { once: true });
  }

  window.addEventListener('message', function (event) {
    var payload = event.data || {};
    if (payload.type !== 'fbp-support-chat-v2:frame-state') return;

    var frame = findChatFrame();
    if (frame && event.source && frame.contentWindow && event.source !== frame.contentWindow) {
      return;
    }

    latestFrameState.visible = Boolean(payload.visible);
    latestFrameState.open = Boolean(payload.open);
    latestFrameState.width = Math.max(0, Number(payload.width || 0));
    latestFrameState.height = Math.max(0, Number(payload.height || 0));

    scheduleChatFrameOffset();
  });

  injectDockStyles();
  ensureDockTrigger();
  armDeferredLoad();
})();
